export default "__VITE_PUBLIC_ASSET__c5e49d63__"